import React from "react";
import styles from "./LiveMetricsReport2.module.css";

function LiveMetricsReport2({ metrics }) {
  // console.log(props.data)

  // determine color coding for live metrics
  const determineColor = (
    metricValue,
    thresholdLow,
    thresholdHigh,
    metricProp
  ) => {
    if (metricProp === "fuel") {
      if (metricValue === 0) {
        return {
          backgroundColor: "#F1F1F1",
          iconColor: "#263238",
          headerColor: "#F1F1F1",
        };
      } else if (metricValue > 0 && metricValue < thresholdLow) {
        return {
          backgroundColor: "#FFDFD7",
          iconColor: "#FD4D1E",
          headerColor: "#ffdfd759",
        };
      } else if (metricValue <= thresholdHigh) {
        return {
          backgroundColor: "#FFF5CC",
          iconColor: "#FF9900",
          headerColor: "#fff5cc66",
        };
      } else {
        return {
          backgroundColor: "#D7FBDB",
          iconColor: "#008069",
          headerColor: "#3F5FFF1",
        };
      }
    } else if (metricProp === "engine load") {
      if (metricValue === 0) {
        return {
          backgroundColor: "#F1F1F1",
          iconColor: "#263238",
          headerColor: "#F1F1F1",
        };
      } else if (
        metricValue > thresholdHigh &&
        metrics?.scan_data?.vehicle_live_data?.speed === 0
      ) {
        return {
          backgroundColor: "#FFDFD7",
          iconColor: "#FD4D1E",
          headerColor: "#ffdfd759",
        };
      } else if (
        metricValue < thresholdHigh &&
        metrics?.scan_data?.vehicle_live_data?.speed === 0
      ) {
        return {
          backgroundColor: "#FFF5CC",
          iconColor: "#FF9900",
          headerColor: "#fff5cc66",
        };
      } else {
        return {
          backgroundColor: "#D7FBDB",
          iconColor: "#008069",
          headerColor: "#3F5FFF1",
        };
      }
    } else if (metricProp === "speed") {
      if (metricValue === 0) {
        return {
          backgroundColor: "#D7FBDB",
          iconColor: "#008069",
          headerColor: "#3F5FFF1",
        };
      } else {
        return {
          backgroundColor: "#FFDFD7",
          iconColor: "#FD4D1E",
          headerColor: "#ffdfd759",
        };
      }
    } else if (metricProp === "pressure") {
      if (metricValue >= thresholdLow && metricValue <= thresholdHigh) {
        return {
          backgroundColor: "#D7FBDB",
          iconColor: "#008069",
          headerColor: "#3F5FFF1",
        };
      } else {
        return {
          backgroundColor: "#FFF5CC",
          iconColor: "#FF9900",
          headerColor: "#fff5cc66",
        };
      }
    } else if (metricProp === "rpm") {
      if (metricValue >= 600 && metricValue <= 650) {
        return {
          backgroundColor: "#FFF5CC",
          iconColor: "#FF9900",
          headerColor: "#fff5cc66",
        };
      } else if (metricValue >= 650 && metricValue <= 850) {
        return {
          backgroundColor: "#D7FBDB",
          iconColor: "#008069",
          headerColor: "#3F5FFF1",
        };
      } else if (metricValue >= 850 && metricValue <= 950) {
        return {
          backgroundColor: "#FFF5CC",
          iconColor: "#FF9900",
          headerColor: "#fff5cc66",
        };
      } else {
        return {
          backgroundColor: "#FFDFD7",
          iconColor: "#FD4D1E",
          headerColor: "#ffdfd759",
        };
      }
    } else {
      if (metricValue === 0) {
        return {
          backgroundColor: "#F1F1F1",
          iconColor: "#263238",
          headerColor: "#F1F1F1",
        };
      } else if (metricValue > 0 && metricValue < thresholdLow) {
        return {
          backgroundColor: "#D7FBDB",
          iconColor: "#008069",
          headerColor: "#3F5FFF1",
        };
      } else if (metricValue <= thresholdHigh) {
        return {
          backgroundColor: "#FFF5CC",
          iconColor: "#FF9900",
          headerColor: "#fff5cc66",
        };
      } else {
        return {
          backgroundColor: "#FFDFD7",
          iconColor: "#FD4D1E",
          headerColor: "#ffdfd759",
        };
      }
    }
  };

  //color code for overheating
  const determineOverheatingColor = (
    metricValue,
    thresholdLow,
    thresholdHigh,
    metricProp
  ) => {
    // metrics determination for those with MetricProps
    if (metricProp === "fuel") {
      if (metricValue === 0) {
        return {
          backgroundColor: "#F1F1F1",
          iconColor: "#263238",
          headerColor: "#F1F1F1",
        };
      } else if (metricValue > 0 && metricValue < thresholdLow) {
        return {
          backgroundColor: "#FFDFD7",
          iconColor: "#FD4D1E",
          headerColor: "#ffdfd759",
        };
      } else if (metricValue <= thresholdHigh) {
        return {
          backgroundColor: "#FFF5CC",
          iconColor: "#FF9900",
          headerColor: "#fff5cc66",
        };
      } else {
        return {
          backgroundColor: "#D7FBDB",
          iconColor: "#008069",
          headerColor: "#3F5FFF1",
        };
      }
    } else if (metricProp === "temp") {
      if (metricValue >= 65 && metricValue <= 82) {
        return {
          backgroundColor: "#FFF5CC",
          iconColor: "#FF9900",
          headerColor: "#fff5cc66",
        };
      } else if (metricValue >= 83 && metricValue <= 92) {
        return {
          backgroundColor: "#D7FBDB",
          iconColor: "#008069",
          headerColor: "#3F5FFF1",
        };
      } else if (metricValue >= 92 && metricValue <= 98) {
        return {
          backgroundColor: "#FFF5CC",
          iconColor: "#FF9900",
          headerColor: "#fff5cc66",
        };
      } else {
        return {
          backgroundColor: "#FFDFD7",
          iconColor: "#FD4D1E",
          headerColor: "#ffdfd759",
        };
      }
    }
    if (metricValue === 0) {
      return {
        backgroundColor: "#F1F1F1",
        iconColor: "#263238",
        headerColor: "#F1F1F1",
      };
    } else if (metricValue > 0 && metricValue < thresholdLow) {
      return {
        backgroundColor: "#FFF5CC",
        iconColor: "#FF9900",
        headerColor: "#fff5cc66",
      };
    } else if (metricValue <= thresholdHigh) {
      return {
        backgroundColor: "#D7FBDB",
        iconColor: "#008069",
        headerColor: "#3F5FFF1",
      };
    } else {
      return {
        backgroundColor: "#FFDFD7",
        iconColor: "#FD4D1E",
        headerColor: "#ffdfd759",
      };
    }
  };
  return (
    <div className={styles.carStatus2}>
      <div className={styles.carStatus__inner}>
        <h4>Live Metrics</h4>
        <h4>Status</h4>
      </div>

      <div className={styles.metrics_card}>
        <div className={styles.metrics_header}>
          <p>Battery</p>
        </div>
        <div className={styles.metrics_content}>
          <div className={styles.metrics_content_inner}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 4.5V6H9V4.5H6ZM15 4.5V6H18V4.5H15ZM3 6.75V20.25H21V6.75H3ZM4.5 8.25H19.5V18.75H4.5V8.25ZM15 11.25V12.75H13.5V14.25H15V15.75H16.5V14.25H18V12.75H16.5V11.25H15ZM6 12.75V14.25H10.5V12.75H6Z"
                fill="#008069"
              />
            </svg>
            <p>Current Temperature</p>
          </div>
          <div>
            <p>{`${
              Number(metrics?.scan_data?.vehicle_live_data?.voltage) === 0
                ? "Not available"
                : Number(metrics?.scan_data?.vehicle_live_data?.voltage)
            }`}</p>
          </div>
        </div>
      </div>

      <div className={styles.metrics_card}>
        <div
          className={styles.metrics_header}
          style={{
            backgroundColor: determineColor(
              metrics?.scan_data?.vehicle_live_data?.engine_speed,
              600,
              1500,
              "rpm"
            ).headerColor,
          }}
        >
          <p>RPM</p>
          {/* <p>+13%</p> */}
        </div>
        <div
          className={styles.metrics_content}
          style={{
            backgroundColor: determineColor(
              metrics?.scan_data?.vehicle_live_data?.engine_speed,
              600,
              1500,
              "rpm"
            ).backgroundColor,
          }}
        >
          <div className={styles.metrics_content_inner}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.543 5.483C7.87441 4.36487 9.51793 3.684 11.25 3.533V5.25C11.25 5.44891 11.329 5.63968 11.4697 5.78033C11.6103 5.92098 11.8011 6 12 6C12.1989 6 12.3897 5.92098 12.5303 5.78033C12.671 5.63968 12.75 5.44891 12.75 5.25V3.533C14.7802 3.71332 16.678 4.61697 18.0978 6.07931C19.5176 7.54166 20.3647 9.46537 20.485 11.5H18.75C18.5511 11.5 18.3603 11.579 18.2197 11.7197C18.079 11.8603 18 12.0511 18 12.25C18 12.4489 18.079 12.6397 18.2197 12.7803C18.3603 12.921 18.5511 13 18.75 13H20.444C20.184 15.312 19.021 17.248 17.276 18.668C17.1216 18.7937 17.0236 18.9756 17.0033 19.1736C16.983 19.3717 17.0423 19.5696 17.168 19.724C17.2937 19.8784 17.4756 19.9764 17.6736 19.9967C17.8717 20.017 18.0696 19.9577 18.224 19.832C20.45 18.019 21.894 15.438 21.994 12.347C22.0007 12.2953 22.002 12.243 21.998 12.191L22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 15.252 3.523 17.954 5.77 19.826C5.92338 19.9477 6.11827 20.0046 6.31303 19.9845C6.5078 19.9645 6.68699 19.869 6.81234 19.7186C6.93768 19.5682 6.99924 19.3747 6.98385 19.1795C6.96847 18.9844 6.87736 18.8029 6.73 18.674C5.02 17.248 3.827 15.307 3.558 13H5.25C5.44891 13 5.63968 12.921 5.78033 12.7803C5.92098 12.6397 6 12.4489 6 12.25C6 12.0511 5.92098 11.8603 5.78033 11.7197C5.63968 11.579 5.44891 11.5 5.25 11.5H3.514C3.624 9.618 4.345 7.9 5.483 6.543L6.72 7.78C6.86217 7.91248 7.05022 7.9846 7.24452 7.98117C7.43882 7.97775 7.62421 7.89903 7.76162 7.76162C7.89903 7.62421 7.97775 7.43882 7.98117 7.24452C7.9846 7.05022 7.91248 6.86217 7.78 6.72L6.543 5.483ZM16.76 6.634C16.6438 6.5445 16.5005 6.49723 16.3539 6.49995C16.2072 6.50268 16.0658 6.55524 15.953 6.649L15.735 6.832C14.9488 7.49228 14.1651 8.15562 13.384 8.822C12.728 9.382 12.057 9.962 11.521 10.435C11.2889 10.639 11.0592 10.8456 10.832 11.055C10.6837 11.1878 10.5434 11.3294 10.412 11.479C10.2569 11.6699 10.1417 11.8901 10.0733 12.1264C10.0049 12.3626 9.98466 12.6103 10.0138 12.8545C10.0429 13.0988 10.1207 13.3347 10.2427 13.5483C10.3647 13.7619 10.5284 13.9488 10.724 14.098C11.1224 14.4052 11.6248 14.545 12.1246 14.4879C12.6243 14.4308 13.0822 14.1811 13.401 13.792C13.489 13.684 13.606 13.496 13.726 13.295C13.854 13.08 14.011 12.805 14.185 12.497C14.532 11.877 14.953 11.105 15.36 10.352C15.8434 9.45498 16.323 8.55597 16.799 7.655L16.93 7.406C16.9973 7.27795 17.0172 7.13022 16.9861 6.98894C16.955 6.84766 16.8749 6.72193 16.76 6.634Z"
                fill={
                  determineColor(
                    metrics?.scan_data?.vehicle_live_data?.engine_speed,
                    600,
                    1500,
                    "rpm"
                  ).iconColor
                }
              />
              <path
                d="M6.543 5.483C7.87441 4.36487 9.51793 3.684 11.25 3.533V5.25C11.25 5.44891 11.329 5.63968 11.4697 5.78033C11.6103 5.92098 11.8011 6 12 6C12.1989 6 12.3897 5.92098 12.5303 5.78033C12.671 5.63968 12.75 5.44891 12.75 5.25V3.533C14.7802 3.71332 16.678 4.61697 18.0978 6.07931C19.5176 7.54166 20.3647 9.46537 20.485 11.5H18.75C18.5511 11.5 18.3603 11.579 18.2197 11.7197C18.079 11.8603 18 12.0511 18 12.25C18 12.4489 18.079 12.6397 18.2197 12.7803C18.3603 12.921 18.5511 13 18.75 13H20.444C20.184 15.312 19.021 17.248 17.276 18.668C17.1216 18.7937 17.0236 18.9756 17.0033 19.1736C16.983 19.3717 17.0423 19.5696 17.168 19.724C17.2937 19.8784 17.4756 19.9764 17.6736 19.9967C17.8717 20.017 18.0696 19.9577 18.224 19.832C20.45 18.019 21.894 15.438 21.994 12.347C22.0007 12.2953 22.002 12.243 21.998 12.191L22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 15.252 3.523 17.954 5.77 19.826C5.92338 19.9477 6.11827 20.0046 6.31303 19.9845C6.5078 19.9645 6.68699 19.869 6.81234 19.7186C6.93768 19.5682 6.99924 19.3747 6.98385 19.1795C6.96847 18.9844 6.87736 18.8029 6.73 18.674C5.02 17.248 3.827 15.307 3.558 13H5.25C5.44891 13 5.63968 12.921 5.78033 12.7803C5.92098 12.6397 6 12.4489 6 12.25C6 12.0511 5.92098 11.8603 5.78033 11.7197C5.63968 11.579 5.44891 11.5 5.25 11.5H3.514C3.624 9.618 4.345 7.9 5.483 6.543L6.72 7.78C6.86217 7.91248 7.05022 7.9846 7.24452 7.98117C7.43882 7.97775 7.62421 7.89903 7.76162 7.76162C7.89903 7.62421 7.97775 7.43882 7.98117 7.24452C7.9846 7.05022 7.91248 6.86217 7.78 6.72L6.543 5.483ZM16.76 6.634C16.6438 6.5445 16.5005 6.49723 16.3539 6.49995C16.2072 6.50268 16.0658 6.55524 15.953 6.649L15.735 6.832C14.9488 7.49228 14.1651 8.15562 13.384 8.822C12.728 9.382 12.057 9.962 11.521 10.435C11.2889 10.639 11.0592 10.8456 10.832 11.055C10.6837 11.1878 10.5434 11.3294 10.412 11.479C10.2569 11.6699 10.1417 11.8901 10.0733 12.1264C10.0049 12.3626 9.98466 12.6103 10.0138 12.8545C10.0429 13.0988 10.1207 13.3347 10.2427 13.5483C10.3647 13.7619 10.5284 13.9488 10.724 14.098C11.1224 14.4052 11.6248 14.545 12.1246 14.4879C12.6243 14.4308 13.0822 14.1811 13.401 13.792C13.489 13.684 13.606 13.496 13.726 13.295C13.854 13.08 14.011 12.805 14.185 12.497C14.532 11.877 14.953 11.105 15.36 10.352C15.8434 9.45498 16.323 8.55597 16.799 7.655L16.93 7.406C16.9973 7.27795 17.0172 7.13022 16.9861 6.98894C16.955 6.84766 16.8749 6.72193 16.76 6.634Z"
                fill={
                  determineColor(
                    metrics?.scan_data?.vehicle_live_data?.engine_speed,
                    600,
                    1500,
                    "rpm"
                  ).iconColor
                }
              />
            </svg>

            <p>Current Reading</p>
          </div>
          <div>
            <p
              style={{
                color: determineColor(
                  metrics?.scan_data?.vehicle_live_data?.engine_speed,
                  600,
                  1500,
                  "rpm"
                ).iconColor,
              }}
            >
              {" "}
              {metrics?.scan_data?.vehicle_live_data?.engine_speed || 0}RPM
            </p>
          </div>
        </div>
      </div>

      <div className={styles.metrics_card}>
        <div
          className={styles.metrics_header}
          style={{
            backgroundColor: determineOverheatingColor(
              Number(
                metrics?.scan_data?.vehicle_live_data?.coolant_temperature.replace(
                  "℃",
                  ""
                )
              ),
              0,
              0,
              "temp"
            ).headerColor,
          }}
        >
          <p>Current Temperature</p>
          {/* <p>+13%</p> */}
        </div>
        <div
          className={styles.metrics_content}
          style={{
            backgroundColor: determineOverheatingColor(
              Number(
                metrics?.scan_data?.vehicle_live_data?.coolant_temperature.replace(
                  "℃",
                  ""
                )
              ),
              0,
              0,
              "temp"
            ).backgroundColor,
          }}
        >
          <div className={styles.metrics_content_inner}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21ZM12 22.5C9.21523 22.5 6.54451 21.3938 4.57538 19.4246C2.60625 17.4555 1.5 14.7848 1.5 12C1.5 9.21523 2.60625 6.54451 4.57538 4.57538C6.54451 2.60625 9.21523 1.5 12 1.5C14.7848 1.5 17.4555 2.60625 19.4246 4.57538C21.3938 6.54451 22.5 9.21523 22.5 12C22.5 14.7848 21.3938 17.4555 19.4246 19.4246C17.4555 21.3938 14.7848 22.5 12 22.5Z"
                fill={
                  determineOverheatingColor(
                    Number(
                      metrics?.scan_data?.vehicle_live_data?.coolant_temperature.replace(
                        "℃",
                        ""
                      )
                    ),
                    0,
                    0,
                    "temp"
                  ).iconColor
                }
              />
              <path
                d="M4.5 12C4.5 10.0109 5.29018 8.10322 6.6967 6.6967C8.10322 5.29018 10.0109 4.5 12 4.5C13.9891 4.5 15.8968 5.29018 17.3033 6.6967C18.7098 8.10322 19.5 10.0109 19.5 12C19.5 12.1989 19.421 12.3897 19.2803 12.5303C19.1397 12.671 18.9489 12.75 18.75 12.75C18.5511 12.75 18.3603 12.671 18.2197 12.5303C18.079 12.3897 18 12.1989 18 12C18 10.4087 17.3679 8.88258 16.2426 7.75736C15.1174 6.63214 13.5913 6 12 6C10.4087 6 8.88258 6.63214 7.75736 7.75736C6.63214 8.88258 6 10.4087 6 12C6 12.1989 5.92098 12.3897 5.78033 12.5303C5.63968 12.671 5.44891 12.75 5.25 12.75C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12Z"
                fill={
                  determineOverheatingColor(
                    Number(
                      metrics?.scan_data?.vehicle_live_data?.coolant_temperature.replace(
                        "℃",
                        ""
                      )
                    ),
                    0,
                    0,
                    "temp"
                  ).iconColor
                }
              />
              <path
                d="M13.3687 14.7152C13.7896 15.0386 14.0827 15.5003 14.1961 16.0188C14.3095 16.5373 14.236 17.0791 13.9885 17.5487C13.741 18.0182 13.3355 18.3851 12.8437 18.5846C12.3519 18.7841 11.8053 18.8033 11.3007 18.6388C10.7961 18.4743 10.3659 18.1367 10.0861 17.6857C9.8063 17.2347 9.69494 16.6993 9.77171 16.1741C9.84848 15.6489 10.1084 15.1678 10.5056 14.8158C10.9028 14.4637 11.4116 14.2634 11.9422 14.2502L13.3717 9.84924C13.4013 9.75459 13.4494 9.66675 13.5132 9.59082C13.577 9.51488 13.6553 9.45235 13.7434 9.40685C13.8315 9.36134 13.9278 9.33377 14.0266 9.32572C14.1255 9.31767 14.2249 9.3293 14.3193 9.35995C14.4136 9.3906 14.5009 9.43965 14.5761 9.50426C14.6514 9.56888 14.713 9.64777 14.7576 9.73638C14.8021 9.825 14.8287 9.92156 14.8356 10.0205C14.8426 10.1194 14.8299 10.2188 14.7982 10.3127L13.3687 14.7137V14.7152ZM11.7667 17.2142C11.8605 17.2448 11.9593 17.2565 12.0577 17.2489C12.156 17.2412 12.2518 17.2142 12.3397 17.1695C12.4276 17.1248 12.5058 17.0632 12.5699 16.9883C12.634 16.9133 12.6827 16.8265 12.7132 16.7327C12.7438 16.639 12.7555 16.5401 12.7478 16.4418C12.7402 16.3435 12.7132 16.2477 12.6685 16.1598C12.6238 16.0719 12.5622 15.9937 12.4873 15.9296C12.4123 15.8655 12.3255 15.8168 12.2317 15.7862C12.0424 15.7246 11.8363 15.7407 11.6588 15.831C11.4813 15.9213 11.3469 16.0784 11.2852 16.2677C11.2236 16.4571 11.2397 16.6632 11.3299 16.8407C11.4202 17.0182 11.5774 17.1526 11.7667 17.2142Z"
                fill={
                  determineOverheatingColor(
                    Number(
                      metrics?.scan_data?.vehicle_live_data?.coolant_temperature.replace(
                        "℃",
                        ""
                      )
                    ),
                    0,
                    0,
                    "temp"
                  ).iconColor
                }
              />
            </svg>
            <p>Current Temperature</p>
          </div>
          <div>
            <p
              style={{
                color: determineOverheatingColor(
                  Number(
                    metrics?.scan_data?.vehicle_live_data?.coolant_temperature.replace(
                      "℃",
                      ""
                    )
                  ),
                  0,
                  0,
                  "temp"
                ).iconColor,
              }}
            >
              {metrics
                ? parseFloat(
                    metrics?.scan_data?.vehicle_live_data?.coolant_temperature
                  )
                : 0}{" "}
              ℃
            </p>
          </div>
        </div>
      </div>

      <div className={styles.metrics_card}>
        <div
          className={styles.metrics_header}
          style={{
            backgroundColor: determineColor(
              Number(metrics?.scan_data?.vehicle_live_data?.engine_load),
              29,
              50,
              "engine load"
            ).headerColor,
          }}
        >
          <p>Current Engine Load</p>
          {/* <p>+13%</p> */}
        </div>
        <div
          className={styles.metrics_content}
          style={{
            backgroundColor: determineColor(
              Number(metrics?.scan_data?.vehicle_live_data?.engine_load),
              29,
              50,
              "engine load"
            ).backgroundColor,
          }}
        >
          <div className={styles.metrics_content_inner}>
            <svg
              width="29"
              height="28"
              viewBox="0 0 29 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask id="path-1-inside-1_8667_1061" fill="white">
                <path d="M9.83342 11.667H19.1667V21.0003H13.3334L11.0001 18.667H8.66675V12.8337M8.66675 4.66699V7.00033H12.1667V9.33366H8.66675L6.33342 11.667V15.167H4.00008V11.667H1.66675V21.0003H4.00008V17.5003H6.33342V21.0003H9.83342L12.1667 23.3337H21.5001V18.667H23.8334V22.167H27.3334V10.5003H23.8334V14.0003H21.5001V9.33366H14.5001V7.00033H18.0001V4.66699H8.66675Z" />
              </mask>
              <path
                d="M9.83342 11.667H19.1667V21.0003H13.3334L11.0001 18.667H8.66675V12.8337M8.66675 4.66699V7.00033H12.1667V9.33366H8.66675L6.33342 11.667V15.167H4.00008V11.667H1.66675V21.0003H4.00008V17.5003H6.33342V21.0003H9.83342L12.1667 23.3337H21.5001V18.667H23.8334V22.167H27.3334V10.5003H23.8334V14.0003H21.5001V9.33366H14.5001V7.00033H18.0001V4.66699H8.66675Z"
                fill={
                  determineColor(
                    Number(metrics?.scan_data?.vehicle_live_data?.engine_load),
                    29,
                    50,
                    "engine load"
                  ).iconColor
                }
              />
              <path
                d="M19.1667 11.667H19.8334V11.0003H19.1667V11.667ZM19.1667 21.0003V21.667H19.8334V21.0003H19.1667ZM13.3334 21.0003L12.862 21.4717L13.0573 21.667H13.3334V21.0003ZM11.0001 18.667L11.4715 18.1956L11.2762 18.0003H11.0001V18.667ZM8.66675 18.667H8.00008V19.3337H8.66675V18.667ZM8.66675 4.66699V4.00033H8.00008V4.66699H8.66675ZM8.66675 7.00033H8.00008V7.66699H8.66675V7.00033ZM12.1667 7.00033H12.8334V6.33366H12.1667V7.00033ZM12.1667 9.33366V10.0003H12.8334V9.33366H12.1667ZM8.66675 9.33366V8.66699H8.39061L8.19534 8.86225L8.66675 9.33366ZM6.33342 11.667L5.86201 11.1956L5.66675 11.3909V11.667H6.33342ZM6.33342 15.167V15.8337H7.00008V15.167H6.33342ZM4.00008 15.167H3.33341V15.8337H4.00008V15.167ZM4.00008 11.667H4.66675V11.0003H4.00008V11.667ZM1.66675 11.667V11.0003H1.00008V11.667H1.66675ZM1.66675 21.0003H1.00008V21.667H1.66675V21.0003ZM4.00008 21.0003V21.667H4.66675V21.0003H4.00008ZM4.00008 17.5003V16.8337H3.33341V17.5003H4.00008ZM6.33342 17.5003H7.00008V16.8337H6.33342V17.5003ZM6.33342 21.0003H5.66675V21.667H6.33342V21.0003ZM9.83342 21.0003L10.3048 20.5289L10.1096 20.3337H9.83342V21.0003ZM12.1667 23.3337L11.6953 23.8051L11.8906 24.0003H12.1667V23.3337ZM21.5001 23.3337V24.0003H22.1667V23.3337H21.5001ZM21.5001 18.667V18.0003H20.8334V18.667H21.5001ZM23.8334 18.667H24.5001V18.0003H23.8334V18.667ZM23.8334 22.167H23.1667V22.8337H23.8334V22.167ZM27.3334 22.167V22.8337H28.0001V22.167H27.3334ZM27.3334 10.5003H28.0001V9.83366H27.3334V10.5003ZM23.8334 10.5003V9.83366H23.1667V10.5003H23.8334ZM23.8334 14.0003V14.667H24.5001V14.0003H23.8334ZM21.5001 14.0003H20.8334V14.667H21.5001V14.0003ZM21.5001 9.33366H22.1667V8.66699H21.5001V9.33366ZM14.5001 9.33366H13.8334V10.0003H14.5001V9.33366ZM14.5001 7.00033V6.33366H13.8334V7.00033H14.5001ZM18.0001 7.00033V7.66699H18.6667V7.00033H18.0001ZM18.0001 4.66699H18.6667V4.00033H18.0001V4.66699ZM9.83342 12.3337H19.1667V11.0003H9.83342V12.3337ZM18.5001 11.667V21.0003H19.8334V11.667H18.5001ZM19.1667 20.3337H13.3334V21.667H19.1667V20.3337ZM13.8048 20.5289L11.4715 18.1956L10.5287 19.1384L12.862 21.4717L13.8048 20.5289ZM11.0001 18.0003H8.66675V19.3337H11.0001V18.0003ZM9.33342 18.667V12.8337H8.00008V18.667H9.33342ZM8.00008 4.66699V7.00033H9.33342V4.66699H8.00008ZM8.66675 7.66699H12.1667V6.33366H8.66675V7.66699ZM11.5001 7.00033V9.33366H12.8334V7.00033H11.5001ZM12.1667 8.66699H8.66675V10.0003H12.1667V8.66699ZM8.19534 8.86225L5.86201 11.1956L6.80482 12.1384L9.13815 9.80506L8.19534 8.86225ZM5.66675 11.667V15.167H7.00008V11.667H5.66675ZM6.33342 14.5003H4.00008V15.8337H6.33342V14.5003ZM4.66675 15.167V11.667H3.33341V15.167H4.66675ZM4.00008 11.0003H1.66675V12.3337H4.00008V11.0003ZM1.00008 11.667V21.0003H2.33341V11.667H1.00008ZM1.66675 21.667H4.00008V20.3337H1.66675V21.667ZM4.66675 21.0003V17.5003H3.33341V21.0003H4.66675ZM4.00008 18.167H6.33342V16.8337H4.00008V18.167ZM5.66675 17.5003V21.0003H7.00008V17.5003H5.66675ZM6.33342 21.667H9.83342V20.3337H6.33342V21.667ZM9.36201 21.4717L11.6953 23.8051L12.6382 22.8623L10.3048 20.5289L9.36201 21.4717ZM12.1667 24.0003H21.5001V22.667H12.1667V24.0003ZM22.1667 23.3337V18.667H20.8334V23.3337H22.1667ZM21.5001 19.3337H23.8334V18.0003H21.5001V19.3337ZM23.1667 18.667V22.167H24.5001V18.667H23.1667ZM23.8334 22.8337H27.3334V21.5003H23.8334V22.8337ZM28.0001 22.167V10.5003H26.6667V22.167H28.0001ZM27.3334 9.83366H23.8334V11.167H27.3334V9.83366ZM23.1667 10.5003V14.0003H24.5001V10.5003H23.1667ZM23.8334 13.3337H21.5001V14.667H23.8334V13.3337ZM22.1667 14.0003V9.33366H20.8334V14.0003H22.1667ZM21.5001 8.66699H14.5001V10.0003H21.5001V8.66699ZM15.1667 9.33366V7.00033H13.8334V9.33366H15.1667ZM14.5001 7.66699H18.0001V6.33366H14.5001V7.66699ZM18.6667 7.00033V4.66699H17.3334V7.00033H18.6667ZM18.0001 4.00033H8.66675V5.33366H18.0001V4.00033Z"
                fill={
                  determineColor(
                    Number(metrics?.scan_data?.vehicle_live_data?.engine_load),
                    29,
                    50,
                    "engine load"
                  ).iconColor
                }
                mask="url(#path-1-inside-1_8667_1061)"
              />
            </svg>

            <p>Current Engine Load</p>
          </div>
          <div>
            <p
              style={{
                color: determineColor(
                  Number(metrics?.scan_data?.vehicle_live_data?.engine_load),
                  29,
                  50,
                  "engine load"
                ).iconColor,
              }}
            >
              {metrics?.scan_data?.vehicle_live_data?.engine_load || 0}
            </p>
          </div>
        </div>
      </div>

      <div className={styles.metrics_card}>
        <div
          className={styles.metrics_header}
          style={{
            backgroundColor: determineOverheatingColor(
              parseFloat(metrics?.scan_data?.vehicle_live_data?.remaining_fuel),
              15,
              30,
              "fuel"
            ).headerColor,
          }}
        >
          <p>Fuel Level </p>
          {/* <p>+13%</p> */}
        </div>
        <div
          className={styles.metrics_content}
          style={{
            backgroundColor: determineOverheatingColor(
              parseFloat(metrics?.scan_data?.vehicle_live_data?.remaining_fuel),
              15,
              30,
              "fuel"
            ).backgroundColor,
          }}
        >
          <div className={styles.metrics_content_inner}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_9312_62760)">
                <path
                  d="M4.5 3.75C4.5 3.55109 4.57902 3.36032 4.71967 3.21967C4.86032 3.07902 5.05109 3 5.25 3H12.75C12.9489 3 13.1397 3.07902 13.2803 3.21967C13.421 3.36032 13.5 3.55109 13.5 3.75V11.25C13.5 11.4489 13.421 11.6397 13.2803 11.7803C13.1397 11.921 12.9489 12 12.75 12H5.25C5.05109 12 4.86032 11.921 4.71967 11.7803C4.57902 11.6397 4.5 11.4489 4.5 11.25V3.75Z"
                  fill={
                    determineOverheatingColor(
                      Number(
                        metrics?.scan_data?.vehicle_live_data?.remaining_fuel
                      ),
                      15,
                      30,
                      "fuel"
                    ).iconColor
                  }
                />
                <path
                  d="M1.5 3C1.5 2.20435 1.81607 1.44129 2.37868 0.87868C2.94129 0.316071 3.70435 0 4.5 0L13.5 0C14.2956 0 15.0587 0.316071 15.6213 0.87868C16.1839 1.44129 16.5 2.20435 16.5 3V15C17.2956 15 18.0587 15.3161 18.6213 15.8787C19.1839 16.4413 19.5 17.2044 19.5 18V18.75C19.5 18.9489 19.579 19.1397 19.7197 19.2803C19.8603 19.421 20.0511 19.5 20.25 19.5C20.4489 19.5 20.6397 19.421 20.7803 19.2803C20.921 19.1397 21 18.9489 21 18.75V12H20.25C20.0511 12 19.8603 11.921 19.7197 11.7803C19.579 11.6397 19.5 11.4489 19.5 11.25V6.5625C19.5 6.36359 19.579 6.17282 19.7197 6.03217C19.8603 5.89152 20.0511 5.8125 20.25 5.8125H22.4925C22.476 5.0985 22.413 4.4715 22.191 3.9795C22.0722 3.69343 21.8651 3.45275 21.6 3.2925C21.324 3.1275 20.904 3 20.25 3C20.0511 3 19.8603 2.92098 19.7197 2.78033C19.579 2.63968 19.5 2.44891 19.5 2.25C19.5 2.05109 19.579 1.86032 19.7197 1.71967C19.8603 1.57902 20.0511 1.5 20.25 1.5C21.096 1.5 21.801 1.665 22.368 2.004C22.9425 2.346 23.319 2.8305 23.559 3.3645C24.0015 4.347 24 5.562 24 6.486V11.2485C24.0002 11.3471 23.9809 11.4448 23.9433 11.536C23.9057 11.6271 23.8505 11.71 23.7809 11.7798C23.7112 11.8496 23.6285 11.905 23.5374 11.9428C23.4463 11.9806 23.3486 12 23.25 12H22.5V18.75C22.5 19.3467 22.2629 19.919 21.841 20.341C21.419 20.7629 20.8467 21 20.25 21C19.6533 21 19.081 20.7629 18.659 20.341C18.2371 19.919 18 19.3467 18 18.75V18C18 17.6022 17.842 17.2206 17.5607 16.9393C17.2794 16.658 16.8978 16.5 16.5 16.5V22.5H17.25C17.4489 22.5 17.6397 22.579 17.7803 22.7197C17.921 22.8603 18 23.0511 18 23.25C18 23.4489 17.921 23.6397 17.7803 23.7803C17.6397 23.921 17.4489 24 17.25 24H0.75C0.551088 24 0.360322 23.921 0.21967 23.7803C0.0790176 23.6397 0 23.4489 0 23.25C0 23.0511 0.0790176 22.8603 0.21967 22.7197C0.360322 22.579 0.551088 22.5 0.75 22.5H1.5V3ZM15 3C15 2.60218 14.842 2.22064 14.5607 1.93934C14.2794 1.65804 13.8978 1.5 13.5 1.5H4.5C4.10218 1.5 3.72064 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V22.5H15V3Z"
                  fill={
                    determineOverheatingColor(
                      Number(
                        metrics?.scan_data?.vehicle_live_data?.remaining_fuel
                      ),
                      15,
                      30,
                      "fuel"
                    ).iconColor
                  }
                />
                <path
                  d="M4.5 3.75C4.5 3.55109 4.57902 3.36032 4.71967 3.21967C4.86032 3.07902 5.05109 3 5.25 3H12.75C12.9489 3 13.1397 3.07902 13.2803 3.21967C13.421 3.36032 13.5 3.55109 13.5 3.75V11.25C13.5 11.4489 13.421 11.6397 13.2803 11.7803C13.1397 11.921 12.9489 12 12.75 12H5.25C5.05109 12 4.86032 11.921 4.71967 11.7803C4.57902 11.6397 4.5 11.4489 4.5 11.25V3.75Z"
                  fill={
                    determineOverheatingColor(
                      Number(
                        metrics?.scan_data?.vehicle_live_data?.remaining_fuel
                      ),
                      15,
                      30,
                      "fuel"
                    ).iconColor
                  }
                />
                <path
                  d="M1.5 3C1.5 2.20435 1.81607 1.44129 2.37868 0.87868C2.94129 0.316071 3.70435 0 4.5 0L13.5 0C14.2956 0 15.0587 0.316071 15.6213 0.87868C16.1839 1.44129 16.5 2.20435 16.5 3V15C17.2956 15 18.0587 15.3161 18.6213 15.8787C19.1839 16.4413 19.5 17.2044 19.5 18V18.75C19.5 18.9489 19.579 19.1397 19.7197 19.2803C19.8603 19.421 20.0511 19.5 20.25 19.5C20.4489 19.5 20.6397 19.421 20.7803 19.2803C20.921 19.1397 21 18.9489 21 18.75V12H20.25C20.0511 12 19.8603 11.921 19.7197 11.7803C19.579 11.6397 19.5 11.4489 19.5 11.25V6.5625C19.5 6.36359 19.579 6.17282 19.7197 6.03217C19.8603 5.89152 20.0511 5.8125 20.25 5.8125H22.4925C22.476 5.0985 22.413 4.4715 22.191 3.9795C22.0722 3.69343 21.8651 3.45275 21.6 3.2925C21.324 3.1275 20.904 3 20.25 3C20.0511 3 19.8603 2.92098 19.7197 2.78033C19.579 2.63968 19.5 2.44891 19.5 2.25C19.5 2.05109 19.579 1.86032 19.7197 1.71967C19.8603 1.57902 20.0511 1.5 20.25 1.5C21.096 1.5 21.801 1.665 22.368 2.004C22.9425 2.346 23.319 2.8305 23.559 3.3645C24.0015 4.347 24 5.562 24 6.486V11.2485C24.0002 11.3471 23.9809 11.4448 23.9433 11.536C23.9057 11.6271 23.8505 11.71 23.7809 11.7798C23.7112 11.8496 23.6285 11.905 23.5374 11.9428C23.4463 11.9806 23.3486 12 23.25 12H22.5V18.75C22.5 19.3467 22.2629 19.919 21.841 20.341C21.419 20.7629 20.8467 21 20.25 21C19.6533 21 19.081 20.7629 18.659 20.341C18.2371 19.919 18 19.3467 18 18.75V18C18 17.6022 17.842 17.2206 17.5607 16.9393C17.2794 16.658 16.8978 16.5 16.5 16.5V22.5H17.25C17.4489 22.5 17.6397 22.579 17.7803 22.7197C17.921 22.8603 18 23.0511 18 23.25C18 23.4489 17.921 23.6397 17.7803 23.7803C17.6397 23.921 17.4489 24 17.25 24H0.75C0.551088 24 0.360322 23.921 0.21967 23.7803C0.0790176 23.6397 0 23.4489 0 23.25C0 23.0511 0.0790176 22.8603 0.21967 22.7197C0.360322 22.579 0.551088 22.5 0.75 22.5H1.5V3ZM15 3C15 2.60218 14.842 2.22064 14.5607 1.93934C14.2794 1.65804 13.8978 1.5 13.5 1.5H4.5C4.10218 1.5 3.72064 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V22.5H15V3Z"
                  fill={
                    determineOverheatingColor(
                      Number(
                        metrics?.scan_data?.vehicle_live_data?.remaining_fuel
                      ),
                      15,
                      30,
                      "fuel"
                    ).iconColor
                  }
                />
              </g>
              <defs>
                <clipPath id="clip0_9312_62760">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <p>Current Rate</p>
          </div>
          <div>
            <p
              style={{
                color: determineOverheatingColor(
                  Number(metrics?.scan_data?.vehicle_live_data?.remaining_fuel),
                  15,
                  30,
                  "fuel"
                ).iconColor,
              }}
            >
              {metrics
                ? parseFloat(
                    metrics?.scan_data?.vehicle_live_data?.remaining_fuel
                  )
                : 0}
              %
            </p>
          </div>
        </div>
      </div>

      <div className={styles.metrics_card}>
        <div
          className={styles.metrics_header}
          style={{
            backgroundColor: determineColor(
              Number(
                metrics?.scan_data?.vehicle_live_data
                  ?.current_fuel_consumption_rate
              ) /
                parseFloat(
                  metrics?.scan_data?.vehicle_live_data?.vehicle_mileage
                ),
              0.99,
              1
            ).headerColor,
          }}
        >
          <p>Fuel Consumption Rate</p>
        </div>
        <div
          className={styles.metrics_content}
          style={{
            backgroundColor: determineColor(
              Number(
                metrics?.scan_data?.vehicle_live_data
                  ?.current_fuel_consumption_rate
              ) /
                parseFloat(
                  metrics?.scan_data?.vehicle_live_data?.vehicle_mileage
                ),
              0.99,
              1
            ).backgroundColor,
          }}
        >
          <div className={styles.metrics_content_inner}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.5 15C22.4988 12.9959 21.9179 11.0348 20.8275 9.35328L19.7445 10.437C20.5663 11.8172 21 13.3937 21 15H22.5ZM21 7.06053L19.9395 6.00003L13.5143 12.4253C13.057 12.1498 12.5338 12.0028 12 12C11.4067 12 10.8267 12.176 10.3333 12.5056C9.83996 12.8353 9.45544 13.3038 9.22837 13.852C9.00131 14.4002 8.9419 15.0034 9.05766 15.5853C9.17341 16.1672 9.45914 16.7018 9.87869 17.1213C10.2983 17.5409 10.8328 17.8266 11.4147 17.9424C11.9967 18.0581 12.5999 17.9987 13.1481 17.7717C13.6962 17.5446 14.1648 17.1601 14.4944 16.6667C14.8241 16.1734 15 15.5934 15 15C14.9973 14.4659 14.8504 13.9425 14.5748 13.485L21 7.06053ZM12 16.5C11.7033 16.5 11.4133 16.4121 11.1667 16.2472C10.92 16.0824 10.7277 15.8481 10.6142 15.5741C10.5007 15.3 10.471 14.9984 10.5288 14.7074C10.5867 14.4164 10.7296 14.1491 10.9394 13.9394C11.1491 13.7296 11.4164 13.5867 11.7074 13.5289C11.9983 13.471 12.2999 13.5007 12.574 13.6142C12.8481 13.7277 13.0824 13.92 13.2472 14.1667C13.412 14.4133 13.5 14.7034 13.5 15C13.4996 15.3977 13.3415 15.779 13.0602 16.0603C12.779 16.3415 12.3977 16.4996 12 16.5ZM12 6.00003C13.606 6.00076 15.182 6.43448 16.5623 7.25553L17.6528 6.16578C16.068 5.14666 14.2379 4.5735 12.3549 4.50661C10.4719 4.43972 8.60576 4.88156 6.95268 5.78566C5.29961 6.68976 3.92077 8.02268 2.96123 9.6442C2.00168 11.2657 1.49691 13.1159 1.50001 15H3.00001C3.00279 12.6139 3.9519 10.3264 5.63912 8.63914C7.32635 6.95191 9.61392 6.00281 12 6.00003Z"
                fill={
                  determineColor(
                    Number(
                      metrics?.scan_data?.vehicle_live_data
                        ?.current_fuel_consumption_rate
                    ) /
                      parseFloat(
                        metrics?.scan_data?.vehicle_live_data?.vehicle_mileage
                      ),
                    0.99,
                    1
                  ).iconColor
                }
              />
            </svg>

            <p>Current Rate</p>
          </div>
          <div>
            <p
              style={{
                color: determineColor(
                  Number(
                    metrics?.scan_data?.vehicle_live_data
                      ?.current_fuel_consumption_rate
                  ) /
                    parseFloat(
                      metrics?.scan_data?.vehicle_live_data?.vehicle_mileage
                    ),
                  0.99,
                  1
                ).iconColor,
              }}
            >
              {(
                parseFloat(
                  metrics?.scan_data?.vehicle_live_data
                    ?.current_fuel_consumption_rate
                ) /
                parseFloat(
                  metrics?.scan_data?.vehicle_live_data?.vehicle_mileage
                )
              ).toFixed(2)}
            </p>
          </div>
        </div>
      </div>

      <div className={styles.metrics_card}>
        <div
          className={styles.metrics_header}
          style={{
            backgroundColor: determineColor(
              parseFloat(
                metrics?.scan_data?.vehicle_live_data?.intake_pressure
              ),
              80,
              100,
              "pressure"
            ).headerColor,
          }}
        >
          <p> Air Intake Pressure</p>
          {/* <p>+13%</p> */}
        </div>
        <div
          className={styles.metrics_content}
          style={{
            backgroundColor: determineColor(
              parseFloat(
                metrics?.scan_data?.vehicle_live_data?.intake_pressure
              ),
              80,
              100,
              "pressure"
            ).backgroundColor,
          }}
        >
          <div className={styles.metrics_content_inner}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21ZM12 22.5C9.21523 22.5 6.54451 21.3938 4.57538 19.4246C2.60625 17.4555 1.5 14.7848 1.5 12C1.5 9.21523 2.60625 6.54451 4.57538 4.57538C6.54451 2.60625 9.21523 1.5 12 1.5C14.7848 1.5 17.4555 2.60625 19.4246 4.57538C21.3938 6.54451 22.5 9.21523 22.5 12C22.5 14.7848 21.3938 17.4555 19.4246 19.4246C17.4555 21.3938 14.7848 22.5 12 22.5Z"
                fill={
                  determineColor(
                    parseFloat(
                      metrics?.scan_data?.vehicle_live_data?.intake_pressure
                    ),
                    80,
                    100,
                    "pressure"
                  ).iconColor
                }
              />
              <path
                d="M4.5 12C4.5 10.0109 5.29018 8.10322 6.6967 6.6967C8.10322 5.29018 10.0109 4.5 12 4.5C13.9891 4.5 15.8968 5.29018 17.3033 6.6967C18.7098 8.10322 19.5 10.0109 19.5 12C19.5 12.1989 19.421 12.3897 19.2803 12.5303C19.1397 12.671 18.9489 12.75 18.75 12.75C18.5511 12.75 18.3603 12.671 18.2197 12.5303C18.079 12.3897 18 12.1989 18 12C18 10.4087 17.3679 8.88258 16.2426 7.75736C15.1174 6.63214 13.5913 6 12 6C10.4087 6 8.88258 6.63214 7.75736 7.75736C6.63214 8.88258 6 10.4087 6 12C6 12.1989 5.92098 12.3897 5.78033 12.5303C5.63968 12.671 5.44891 12.75 5.25 12.75C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12Z"
                fill={
                  determineColor(
                    parseFloat(
                      metrics?.scan_data?.vehicle_live_data?.intake_pressure
                    ),
                    80,
                    100,
                    "pressure"
                  ).iconColor
                }
              />
              <path
                d="M13.3687 14.7152C13.7896 15.0386 14.0827 15.5003 14.1961 16.0188C14.3095 16.5373 14.236 17.0791 13.9885 17.5487C13.741 18.0182 13.3355 18.3851 12.8437 18.5846C12.3519 18.7841 11.8053 18.8033 11.3007 18.6388C10.7961 18.4743 10.3659 18.1367 10.0861 17.6857C9.8063 17.2347 9.69494 16.6993 9.77171 16.1741C9.84848 15.6489 10.1084 15.1678 10.5056 14.8158C10.9028 14.4637 11.4116 14.2634 11.9422 14.2502L13.3717 9.84924C13.4013 9.75459 13.4494 9.66675 13.5132 9.59082C13.577 9.51488 13.6553 9.45235 13.7434 9.40685C13.8315 9.36134 13.9278 9.33377 14.0266 9.32572C14.1255 9.31767 14.2249 9.3293 14.3193 9.35995C14.4136 9.3906 14.5009 9.43965 14.5761 9.50426C14.6514 9.56888 14.713 9.64777 14.7576 9.73638C14.8021 9.825 14.8287 9.92156 14.8356 10.0205C14.8426 10.1194 14.8299 10.2188 14.7982 10.3127L13.3687 14.7137V14.7152ZM11.7667 17.2142C11.8605 17.2448 11.9593 17.2565 12.0577 17.2489C12.156 17.2412 12.2518 17.2142 12.3397 17.1695C12.4276 17.1248 12.5058 17.0632 12.5699 16.9883C12.634 16.9133 12.6827 16.8265 12.7132 16.7327C12.7438 16.639 12.7555 16.5401 12.7478 16.4418C12.7402 16.3435 12.7132 16.2477 12.6685 16.1598C12.6238 16.0719 12.5622 15.9937 12.4873 15.9296C12.4123 15.8655 12.3255 15.8168 12.2317 15.7862C12.0424 15.7246 11.8363 15.7407 11.6588 15.831C11.4813 15.9213 11.3469 16.0784 11.2852 16.2677C11.2236 16.4571 11.2397 16.6632 11.3299 16.8407C11.4202 17.0182 11.5774 17.1526 11.7667 17.2142Z"
                fill={
                  determineColor(
                    parseFloat(
                      metrics?.scan_data?.vehicle_live_data?.intake_pressure
                    ),
                    80,
                    100,
                    "pressure"
                  ).iconColor
                }
              />
            </svg>
            <p>Current Pressure</p>
          </div>
          <div>
            <p
              style={{
                color: determineColor(
                  parseFloat(
                    metrics?.scan_data?.vehicle_live_data?.intake_pressure
                  ),
                  80,
                  100,
                  "pressure"
                ).iconColor,
              }}
            >
              {" "}
              {metrics
                ? parseFloat(
                    metrics?.scan_data?.vehicle_live_data?.intake_pressure
                  )
                : 0}{" "}
              ℃
            </p>
          </div>
        </div>
      </div>

      <div className={styles.metrics_card}>
        <div
          className={styles.metrics_header}
          style={{
            backgroundColor: determineColor(
              metrics?.scan_data?.vehicle_live_data?.speed,
              0,
              1,
              "speed"
            ).headerColor,
          }}
        >
          <p>Speed</p>
          {/* <p>+13%</p> */}
        </div>
        <div
          className={styles.metrics_content}
          style={{
            backgroundColor: determineColor(
              metrics?.scan_data?.vehicle_live_data?.speed,
              0,
              1,
              "speed"
            ).backgroundColor,
          }}
        >
          <div className={styles.metrics_content_inner}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.543 5.483C7.87441 4.36487 9.51793 3.684 11.25 3.533V5.25C11.25 5.44891 11.329 5.63968 11.4697 5.78033C11.6103 5.92098 11.8011 6 12 6C12.1989 6 12.3897 5.92098 12.5303 5.78033C12.671 5.63968 12.75 5.44891 12.75 5.25V3.533C14.7802 3.71332 16.678 4.61697 18.0978 6.07931C19.5176 7.54166 20.3647 9.46537 20.485 11.5H18.75C18.5511 11.5 18.3603 11.579 18.2197 11.7197C18.079 11.8603 18 12.0511 18 12.25C18 12.4489 18.079 12.6397 18.2197 12.7803C18.3603 12.921 18.5511 13 18.75 13H20.444C20.184 15.312 19.021 17.248 17.276 18.668C17.1216 18.7937 17.0236 18.9756 17.0033 19.1736C16.983 19.3717 17.0423 19.5696 17.168 19.724C17.2937 19.8784 17.4756 19.9764 17.6736 19.9967C17.8717 20.017 18.0696 19.9577 18.224 19.832C20.45 18.019 21.894 15.438 21.994 12.347C22.0007 12.2953 22.002 12.243 21.998 12.191L22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 15.252 3.523 17.954 5.77 19.826C5.92338 19.9477 6.11827 20.0046 6.31303 19.9845C6.5078 19.9645 6.68699 19.869 6.81234 19.7186C6.93768 19.5682 6.99924 19.3747 6.98385 19.1795C6.96847 18.9844 6.87736 18.8029 6.73 18.674C5.02 17.248 3.827 15.307 3.558 13H5.25C5.44891 13 5.63968 12.921 5.78033 12.7803C5.92098 12.6397 6 12.4489 6 12.25C6 12.0511 5.92098 11.8603 5.78033 11.7197C5.63968 11.579 5.44891 11.5 5.25 11.5H3.514C3.624 9.618 4.345 7.9 5.483 6.543L6.72 7.78C6.86217 7.91248 7.05022 7.9846 7.24452 7.98117C7.43882 7.97775 7.62421 7.89903 7.76162 7.76162C7.89903 7.62421 7.97775 7.43882 7.98117 7.24452C7.9846 7.05022 7.91248 6.86217 7.78 6.72L6.543 5.483ZM16.76 6.634C16.6438 6.5445 16.5005 6.49723 16.3539 6.49995C16.2072 6.50268 16.0658 6.55524 15.953 6.649L15.735 6.832C14.9488 7.49228 14.1651 8.15562 13.384 8.822C12.728 9.382 12.057 9.962 11.521 10.435C11.2889 10.639 11.0592 10.8456 10.832 11.055C10.6837 11.1878 10.5434 11.3294 10.412 11.479C10.2569 11.6699 10.1417 11.8901 10.0733 12.1264C10.0049 12.3626 9.98466 12.6103 10.0138 12.8545C10.0429 13.0988 10.1207 13.3347 10.2427 13.5483C10.3647 13.7619 10.5284 13.9488 10.724 14.098C11.1224 14.4052 11.6248 14.545 12.1246 14.4879C12.6243 14.4308 13.0822 14.1811 13.401 13.792C13.489 13.684 13.606 13.496 13.726 13.295C13.854 13.08 14.011 12.805 14.185 12.497C14.532 11.877 14.953 11.105 15.36 10.352C15.8434 9.45498 16.323 8.55597 16.799 7.655L16.93 7.406C16.9973 7.27795 17.0172 7.13022 16.9861 6.98894C16.955 6.84766 16.8749 6.72193 16.76 6.634Z"
                fill={
                  determineColor(
                    metrics?.scan_data?.vehicle_live_data?.speed,
                    0,
                    1,
                    "speed"
                  ).iconColor
                }
              />
              <path
                d="M6.543 5.483C7.87441 4.36487 9.51793 3.684 11.25 3.533V5.25C11.25 5.44891 11.329 5.63968 11.4697 5.78033C11.6103 5.92098 11.8011 6 12 6C12.1989 6 12.3897 5.92098 12.5303 5.78033C12.671 5.63968 12.75 5.44891 12.75 5.25V3.533C14.7802 3.71332 16.678 4.61697 18.0978 6.07931C19.5176 7.54166 20.3647 9.46537 20.485 11.5H18.75C18.5511 11.5 18.3603 11.579 18.2197 11.7197C18.079 11.8603 18 12.0511 18 12.25C18 12.4489 18.079 12.6397 18.2197 12.7803C18.3603 12.921 18.5511 13 18.75 13H20.444C20.184 15.312 19.021 17.248 17.276 18.668C17.1216 18.7937 17.0236 18.9756 17.0033 19.1736C16.983 19.3717 17.0423 19.5696 17.168 19.724C17.2937 19.8784 17.4756 19.9764 17.6736 19.9967C17.8717 20.017 18.0696 19.9577 18.224 19.832C20.45 18.019 21.894 15.438 21.994 12.347C22.0007 12.2953 22.002 12.243 21.998 12.191L22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 15.252 3.523 17.954 5.77 19.826C5.92338 19.9477 6.11827 20.0046 6.31303 19.9845C6.5078 19.9645 6.68699 19.869 6.81234 19.7186C6.93768 19.5682 6.99924 19.3747 6.98385 19.1795C6.96847 18.9844 6.87736 18.8029 6.73 18.674C5.02 17.248 3.827 15.307 3.558 13H5.25C5.44891 13 5.63968 12.921 5.78033 12.7803C5.92098 12.6397 6 12.4489 6 12.25C6 12.0511 5.92098 11.8603 5.78033 11.7197C5.63968 11.579 5.44891 11.5 5.25 11.5H3.514C3.624 9.618 4.345 7.9 5.483 6.543L6.72 7.78C6.86217 7.91248 7.05022 7.9846 7.24452 7.98117C7.43882 7.97775 7.62421 7.89903 7.76162 7.76162C7.89903 7.62421 7.97775 7.43882 7.98117 7.24452C7.9846 7.05022 7.91248 6.86217 7.78 6.72L6.543 5.483ZM16.76 6.634C16.6438 6.5445 16.5005 6.49723 16.3539 6.49995C16.2072 6.50268 16.0658 6.55524 15.953 6.649L15.735 6.832C14.9488 7.49228 14.1651 8.15562 13.384 8.822C12.728 9.382 12.057 9.962 11.521 10.435C11.2889 10.639 11.0592 10.8456 10.832 11.055C10.6837 11.1878 10.5434 11.3294 10.412 11.479C10.2569 11.6699 10.1417 11.8901 10.0733 12.1264C10.0049 12.3626 9.98466 12.6103 10.0138 12.8545C10.0429 13.0988 10.1207 13.3347 10.2427 13.5483C10.3647 13.7619 10.5284 13.9488 10.724 14.098C11.1224 14.4052 11.6248 14.545 12.1246 14.4879C12.6243 14.4308 13.0822 14.1811 13.401 13.792C13.489 13.684 13.606 13.496 13.726 13.295C13.854 13.08 14.011 12.805 14.185 12.497C14.532 11.877 14.953 11.105 15.36 10.352C15.8434 9.45498 16.323 8.55597 16.799 7.655L16.93 7.406C16.9973 7.27795 17.0172 7.13022 16.9861 6.98894C16.955 6.84766 16.8749 6.72193 16.76 6.634Z"
                fill={
                  determineColor(
                    metrics?.scan_data?.vehicle_live_data?.speed,
                    0,
                    1,
                    "speed"
                  ).iconColor
                }
              />
            </svg>

            <p>Current Reading</p>
          </div>
          <div>
            <p
              style={{
                color: determineColor(
                  metrics?.scan_data?.vehicle_live_data?.speed,
                  0,
                  1,
                  "speed"
                ).iconColor,
              }}
            >
              {" "}
              {metrics?.scan_data?.vehicle_live_data?.speed || 0}Km/h
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveMetricsReport2;
